import { roundHalfUp } from './math.js';
export function computeRespiratoryRate(taps, elapsedMs) {
    if (!Number.isFinite(taps) || !Number.isFinite(elapsedMs))
        return { ok: false, reason: 'outOfRange' };
    if (elapsedMs < 10_000)
        return { ok: false, reason: 'tooShort' };
    if (taps < 1)
        return { ok: false, reason: 'noTaps' };
    const rate = roundHalfUp((taps * 60_000) / elapsedMs);
    if (rate > 200)
        return { ok: false, reason: 'outOfRange' };
    return { ok: true, rate };
}
